import { render } from "./Types.vue?vue&type=template&id=537a24ee"
import script from "./Types.vue?vue&type=script&lang=js"
export * from "./Types.vue?vue&type=script&lang=js"
script.render = render

export default script